import { render, staticRenderFns } from "./CollectionCardThumbnail.vue?vue&type=template&id=063e0c1d&"
import script from "./CollectionCardThumbnail.vue?vue&type=script&lang=ts&"
export * from "./CollectionCardThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports